import { showErrorModal } from './show-error-modal';
export const getStopAIHeadingStructureModalProps = t => ({
  content: t('accessibility-wizard.heading-structure.stop-ai-modal.content'),
  primaryButtonText: t('accessibility-wizard.heading-structure.stop-ai-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.heading-structure.stop-ai-modal.secondary-button'),
  skin: 'destructive',
  title: t('accessibility-wizard.heading-structure.stop-ai-modal.title')
});
export const showStopAIHeadingStructureModal = _ref => {
  let {
    handleContinue,
    handleStop,
    a11yWizardAdapter,
    t,
    editorHost
  } = _ref;
  showErrorModal({
    ...getStopAIHeadingStructureModalProps(t),
    a11yWizardAdapter,
    editorHost,
    onCloseButtonClick: handleContinue,
    primaryButtonOnClick: handleContinue,
    secondaryButtonOnClick: handleStop
  });
};
//# sourceMappingURL=show-stop-ai-heading-structure-modal.js.map